export default {
  namespaced: true,
  state     : {
    employee_study_courses_business_plus_summary: {
      content: {
        search    : '',
        pagination: {
          rowsPerPage: 10,
        },
        body          : [],
        headers       : [],
        isBusinessPlus: 1,
      },
    },
    showed_courses_business_plus_summary_filter: false,
  },
  getters: {
    employee_study_courses_business_plus_summary: ({employee_study_courses_business_plus_summary}) => employee_study_courses_business_plus_summary,
    showed_courses_business_plus_summary_filter : ({showed_courses_business_plus_summary_filter}) => showed_courses_business_plus_summary_filter,
  },
  mutations: {
    TOGGLE_COURSES_BUSINESS_PLUS_SUMMARY_FILTER(state) {
      state.showed_courses_business_plus_summary_filter = !state.showed_courses_business_plus_summary_filter;
    },
    SET_COURSES_BUSINESS_PLUS_SUMMARY_PER_PAGE(state, perPage) {
      const table = state.employee_study_courses_business_plus_summary.content;
      table.pagination.rowsPerPage = perPage;
    },
    SET_COURSES_BUSINESS_PLUS_SUMMARY_HEADERS(state, coursesAsHeaders) {
      const table = state.employee_study_courses_business_plus_summary.content;
      const dynamicHeaders = coursesAsHeaders.map((courseAsHeader) => ({
        text       : courseAsHeader.name,
        value      : courseAsHeader.id,
        sort       : true,
        inner_items: [
          {text: 'За курс', value: 'base'},
          {text: 'Пройден(да/нет)', value: 'passed'},
        ],
      }));
      table.headers = [
        {text: 'ФИО', value: 'user_fullname', sort: true},
        {text: 'Организация', value: 'company_name', sort: true},
        {text: 'Страна', value: 'country_name', sort: true},
        ...dynamicHeaders,
        {text: 'ИТОГО', value: 'summaryScore'},
      ];
    },
    CHANGE_COURSES_BUSINESS_PLUS_SUMMARY_SORT(state, column) {
      let table = state.employee_study_courses_business_plus_summary.content;
      if (table.pagination.sortBy === column) {
        table.pagination.descending = !table.pagination.descending;
      } else {
        table.pagination.sortBy = column;
        table.pagination.descending = false;
      }
    },
    SET_COURSES_BUSINESS_PLUS_SUMMARY: (state, coursesBusinessPlusSummary) => {
      state.employee_study_courses_business_plus_summary.content.body = coursesBusinessPlusSummary.data.map((courseBusinessPlusSummary) => {
        if (!courseBusinessPlusSummary.courses) return courseBusinessPlusSummary;
        return {
          ...courseBusinessPlusSummary,
          ...courseBusinessPlusSummary.courses.reduce((acc, course) => ({
            ...acc,
            [course.id]: {
              passed: course.score.passed ? 'Да' : 'Нет',
              base  : course.score.base,
            },
          }), {}),
        };
      });
    },
    SET_COURSES_BUSINESS_PLUS_SUMMARY_PAGINATION(state, value) {
      const table = state.employee_study_courses_business_plus_summary.content;
      table.pagination = {...table.pagination, ...value};
    },
    SET_COURSES_BUSINESS_PLUS_SUMMARY_PAGE(state, value) {
      const table = state.employee_study_courses_business_plus_summary.content;
      table.pagination.page = value;
    },
  },
  actions: {
    async change_courses_business_plus_summaries_per_page({commit}, event) {
      commit('SET_COURSES_BUSINESS_PLUS_SUMMARY_PER_PAGE', event);
      commit('SET_COURSES_BUSINESS_PLUS_SUMMARY_PAGE', 1);
    },
  },
};
